import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { getCarrierLabel } from './CarrierOption/CarrierOption'
import { getCarrierError, getHelperText } from './helpers'

const CarrierSelector = ({
  value,
  onChange,
  carriers = [],
  errors,
  showIcon = true,
  showLogo = true,
  manageCarrierService,
  multiple,
  label,
  disabled,
}) => {
  const { t } = useTranslation()

  const handleOnChange = e => {
    if (multiple) {
      onChange(e.target.value)
    } else {
      const selectedCarrier = carriers?.find(carrier => carrier.id === e.target.value)
      onChange(selectedCarrier)
    }
  }

  const getCarrierOptions = () =>
    carriers.map(carrier => ({
      label: getCarrierLabel({ carrier, showIcon, showLogo }),
      value: carrier?.id,
    }))

  return (
    <ComboBox
      label={label || t('Servicio de logística')}
      value={value}
      menuItems={getCarrierOptions()}
      handleChange={handleOnChange}
      helperText={t(getHelperText(errors, value, manageCarrierService))}
      error={getCarrierError(errors)}
      fullWidth
      multiple={multiple}
      disabled={disabled}
    />
  )
}

export default CarrierSelector
